<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full" :head-text="$t('login.sign_up_email')">
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div
          class="purple-round-input input-wrapper relative mb-10 rounded-sm"
          :class="{ focus: focusStatus === 'account', error: verification.account === false }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            type="email"
            v-model="account"
            :placeholder="$t('login.enter_email_address')"
            @input="verify('email', account)"
            @click="focusStatus = 'account'"
          />
          <div v-if="verification.account === false" class="error-msg absolute flex w-full">
            <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
            <span class="text-xs">{{ $t('login.email_sign_up_error_msg') }}</span>
          </div>
        </div>
        <div
          class="purple-round-input input-wrapper relative mb-16 rounded-sm"
          :class="{ focus: focusStatus === 'password', error: verification.password === false }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            :type="inputType"
            v-model="password"
            :placeholder="$t('login.password')"
            @input="verify('password', password)"
            @click="focusStatus = 'password'"
            @keyup.enter="registerEmail"
          />
          <img
            v-if="isHide"
            class="eye-icon absolute"
            src="../../../assets/common/eye.svg"
            @click="isHide = !isHide"
          />
          <img
            v-else
            class="eye-icon absolute"
            src="../../../assets/common/black-eye.svg"
            @click="isHide = !isHide"
          />
          <div v-if="verification.password === false" class="error-msg absolute flex w-full">
            <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
            <span class="text-xs">{{ $t('login.four_characters') }}</span>
          </div>
        </div>
        <c-button :confirmed-status="confirmedStatus" class="relative" @click="registerEmail">
          <template>
            <div v-if="verification.registered" class="button-error-msg absolute h-5 flex w-full">
              <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
              <span class="text-xs">{{ $t('login.try_to_login') }}</span>
            </div>
            <span>{{ $t('login.sign_up') }}</span>
          </template>
        </c-button>
      </template>
    </page>
  </div>
</template>

<script>
import ApiActions from '@/modules/api-actions';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    Page,
    CButton,
  },
  data() {
    return {
      account: '',
      password: '',
      isHide: true,
      focusStatus: 'account',
      verification: {
        account: '',
        password: '',
        registered: false,
      },
    };
  },
  computed: {
    inputType() {
      return this.isHide ? 'password' : 'text';
    },
    confirmedStatus() {
      return !!(this.verification.account && this.verification.password);
    },
  },
  methods: {
    verify(type, data) {
      if (type === 'email') {
        const emailRegExp = /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
        this.verification.account = emailRegExp.test(data);
        return;
      }

      this.verification.password = data.length > 3;
    },
    async registerEmail() {
      if (!this.confirmedStatus) return;

      this.$events.startLoading();
      try {
        const username = await ApiActions.user.registerEmail({
          email: this.account,
          password: this.password,
          provider: 0,
        });
        await ApiActions.user.login({
          username,
          password: this.password,
          provider: 0,
        });
        this.$emit('done');
      } catch (e) {
        this.verification.registered = true;
        console.log(e.message);
        this.$events.stopLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 309px;
}

.error-msg {
  bottom: -24px;
  color: #d12c2d;
}

.button-error-msg {
  top: -35px;
  color: #d12c2d;
}

.eye-icon {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
